<template>
  <div class="navBar flex">
    <div class="cube flex" v-for="(item, index) in listBat" :key="index">
      <div class="circle_one flex-box">
        <img :src="item.img" />
      </div>
      <div>
        <span>{{ item.name }}</span>
        <div class="valueNum" :style="{ color: item.color }">
          <span class="num">{{ item.value }}</span>
          <span class="ys" v-if="item.unit !== ''">({{ item.unit }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "@/api/index";
import { findIndexByName } from "@/util/index";
export default {
  data() {
    return {
      navList: [],
      list: [],
      xzIndex: 0,
      listBat: [
        {
          name: "带动农户",
          img: require("images/granary/nav/ddnh.png"),
          value: 154039,
          color: "#ff9000",
          unit: "户"
        },
        {
          name: "户均增收",
          img: require("images/granary/nav/hjzs.png"),
          value: 4002.07,
          color: "#00ffff",
          unit: "元"
        },
        {
          name: "集体资产总额",
          img: require("images/granary/nav/jtzcze.png"),
          value: 6.9,
          color: "#e7f802",
          unit: "亿元"
        },
        {
          name: "城乡居民收入差距",
          img: require("images/granary/nav/cxjmsrcj.png"),
          value: "1.53 ：1",
          color: "#00ff73",
          unit: ""
        }
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      //toto 动态化
      get("/api/dp/visual/queryList?code=nc_headdata").then(res => {
        const { item, data } = res;
        if (Array.isArray(data) && data.length > 0) {
          const _dt = data[0];
          this.listBat.map(e => {
            const index = findIndexByName(e.name, item, "name");
            if (~index) {
              const code = item[index].code;
              e.value = _dt[code];
              e.unit = item[index].unit;
            }
            return e;
          });
        }
      });
      // getScreenV2Hometbzb().then(res => {
      //   this.listBat = res.data;
      //   this.listBat[0].value = this.listBat[0].value / 10000;
      //   this.listBat[0].unit = "万亩";

      //   this.listBat[0].pic = require("images/index/nav/h_ghmj.png");
      //   this.listBat[1].pic = require("images/index/nav/h_sszt.png");
      //   this.listBat[2].pic = require("images/index/nav/h_zjtr.png");
      //   this.listBat[3].pic = require("images/index/nav/h_jsjd.png");
      //   this.listBat[4].pic = require("images/index/nav/h_lndn.png");
      // });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.navBar
  background-color rgba(1,22,76 , 0.7)
  border-radius 4px
  position absolute
  color #fff
  right calc(27% - 10px)
  left calc(27% - 10px)
  z-index 1
  top 105px
  justify-content space-around
  font-size .06rem
  height .35rem

.cube
//   background url('~images/index/nav/navBg.png') center no-repeat
//   background-size 100% 100%
//   opacity .9
  height 100%
  justify-content center
  width 21%

.valueNum
  color $textColor
.xzBar
  background rgba(11,46,42,0.8)
  box-shadow inset 0px 0px 0.06rem #0ff
.num
  font-size .15rem

.circle_one
  position relative
  margin-right .05rem
  width 60px
  height 60px
  background url('~images/granary/nav/nav-bg.png') no-repeat center
  background-size 100% 100%

  img
    width 30px
    height 30px
    // vertical-align middle
</style>
